import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { InEditorStreamingPluginState } from './reducer';

export const inEditorStreamingPluginKey = new PluginKey<InEditorStreamingPluginState>(
	'inEditorStreaming',
);
